import { useSavedSearchButton } from '../../../../components/SearchPage/components/SavedSearchButton/SavedSearchButton.hook';

import {
  StyledStickyFooter,
  StickySavedSearchButton,
  Container,
  SavedSearchTooltip,
  SaveIcon,
} from '../../../../components/SearchPage/components/SavedSearchButton/SavedSearchButton.styled';
import { VARIANT } from '../../../../components/ToolkitV2/Tooltip/Tooltip.typed';

import type { SavedSearchButtonProps } from '../../../../components/SearchPage/components/SavedSearchButton/SavedSearchButton.typed';

const SavedSearchButton = (props: SavedSearchButtonProps) => {
  const { disabled, onClick, isSavedSearchPromptOpen, closeSavedSearchPrompt } =
    props;

  const { displaySaveSearch } = useSavedSearchButton();

  const onClickSave = () => {
    onClick();
    isSavedSearchPromptOpen && closeSavedSearchPrompt();
  };

  if (disabled) return null;

  return (
    <StyledStickyFooter>
      <Container active={displaySaveSearch || isSavedSearchPromptOpen}>
        <SavedSearchTooltip
          isOpen={isSavedSearchPromptOpen}
          askToClose={closeSavedSearchPrompt}
          headerText="Be the first to know"
          copy="Save this search and we'll notify you when new ads match your selection."
          variant={VARIANT.LIGHT}
          dataTrackingAttribute="save-search-prompt"
        >
          <StickySavedSearchButton
            ofType="TERTIARY"
            onClick={onClickSave}
            icon={<SaveIcon height={24} width={24} />}
          >
            Save this search
          </StickySavedSearchButton>
        </SavedSearchTooltip>
      </Container>
    </StyledStickyFooter>
  );
};

export { SavedSearchButton };
